<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mx-sm-2" for="sStatus">Status </label>
              <b-form-select id="sStatus" :plain="true" :options="statusOption" v-model="sStatus" text-field="label" value-field="value">
                <template slot="first">
                  <option :value="null">-- Please select an option --</option>
                </template>
              </b-form-select>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="getAllGifts"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-gift'></i> Gift</h3>
              <!-- <b-button variant="primary" class="float-right" @click="showModal">Create Gift</b-button> -->
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(image)="data">
                <img :src="data.item.ImageUrl" alt="" style="max-width:150px;">
              </template>
              <template v-slot:cell(Status)="data">
                <b-badge v-if="data.item.Status === 1" variant="success">Enabled</b-badge>
                <b-badge v-else-if="data.item.Status === 0" variant="danger">Disabled</b-badge>
              </template>
              <!-- <template v-slot:cell(action)="data">
                <b-button variant="warning" @click="editGift(data.item.Id)">Edit</b-button>
              </template> -->
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- <b-modal ref="editGift" size="lg" header-bg-variant="primary" hide-footer title="Edit Gift">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.giftName.$error && $v.giftQuantity.$error && $v.giftImageURL.$error)">
                      <label for="giftName">Name</label>
                      <b-form-input type="text" id="giftName" placeholder="Enter Gift Name" v-model.trim="giftName" :state="$v.giftName.$error?false:null" @focus.native="$v.giftName.$touch"></b-form-input>
                      <div v-if="$v.giftName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftName.required">Gift name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftName.minLength">Must have at least {{ $v.giftName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftName.maxLength">Must not exceed {{ $v.giftName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="giftDisplayName">Display Name</label>
                      <b-form-input type="text" id="giftDisplayName" placeholder="Enter Gift Display Name" v-model.trim="giftDisplayName" :state="$v.giftDisplayName.$error?false:null" @focus.native="$v.giftDisplayName.$touch"></b-form-input>
                      <div v-if="$v.giftDisplayName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftDisplayName.required">Display name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftDisplayName.minLength">Must have at least {{ $v.giftDisplayName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftDisplayName.maxLength">Must not exceed {{ $v.giftDisplayName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="giftQuantity">Quantity</label>
                      <b-form-input type="text" id="giftQuantity" placeholder="Enter Gift Quantity" v-model="giftQuantity" :state="$v.giftQuantity.$error?false:null" @focus.native="$v.giftQuantity.$touch"></b-form-input>
                      <div v-if="$v.giftQuantity.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftQuantity.required">Gift quantity is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftQuantity.minValue">Must bigger than {{ $v.giftQuantity.$params.minValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftQuantity.maxValue">Must less than {{ $v.giftQuantity.$params.maxValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftQuantity.numeric">Must be numeric letters</div>
                      </div>

                      <label for="giftImageURL">Image URL</label>
                      <b-form-input type="text" id="giftImageURL" placeholder="Enter Gift Image URL" v-model.trim="giftImageURL" :state="$v.giftImageURL.$error?false:null" @focus.native="$v.giftImageURL.$touch"></b-form-input>
                      <div v-if="$v.giftImageURL.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftImageURL.required">Gift url is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftImageURL.minLength">Must have at least {{ $v.giftImageURL.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftImageURL.maxLength">Must not exceed {{ $v.giftImageURL.$params.maxLength.max}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftImageURL.url">Must be valid url format</div>
                      </div>
                      <b-form-group label="Status" label-for="giftStatus" >
                        <c-switch class="mx-1" variant="success" :value="1" :pill="true" :uncheckedValue="0" v-model="giftStatus" id="giftStatus" @blur.native="$v.giftStatus.$error?false:null" />
                      </b-form-group>
                      <div v-if="$v.giftStatus.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftStatus.required">Gift Status is required</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="updateGift" :disabled="$v.$invalid">Update</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="closeEdit">Cancel</b-btn>
    </b-modal> -->
    <!-- <b-modal ref="createGift" size="lg" header-bg-variant="primary" hide-footer title="Create Gift">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.giftName.$error && $v.giftQuantity.$error && $v.giftImageURL.$error)">
                      <label for="giftName">Name</label>
                      <b-form-input type="text" id="giftName" placeholder="Enter Gift Name" v-model.trim="giftName" :state="$v.giftName.$error?false:null" @focus.native="$v.giftName.$touch"></b-form-input>
                      <div v-if="$v.giftName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftName.required">Gift name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftName.minLength">Must have at least {{ $v.giftName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftName.maxLength">Must not exceed {{ $v.giftName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="giftDisplayName">Display Name</label>
                      <b-form-input type="text" id="giftDisplayName" placeholder="Enter Gift Display Name" v-model.trim="giftDisplayName" :state="$v.giftDisplayName.$error?false:null" @focus.native="$v.giftDisplayName.$touch"></b-form-input>
                      <div v-if="$v.giftDisplayName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftDisplayName.required">Display name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftDisplayName.minLength">Must have at least {{ $v.giftDisplayName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftDisplayName.maxLength">Must not exceed {{ $v.giftDisplayName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="giftQuantity">Quantity</label>
                      <b-form-input type="text" id="giftQuantity" placeholder="Enter Gift Quantity" v-model="giftQuantity" :state="$v.giftQuantity.$error?false:null" @focus.native="$v.giftQuantity.$touch"></b-form-input>
                      <div v-if="$v.giftQuantity.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftQuantity.required">Gift quantity is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftQuantity.minValue">Must bigger than {{ $v.giftQuantity.$params.minValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftQuantity.maxValue">Must less than {{ $v.giftQuantity.$params.maxValue.min}}</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftQuantity.numeric">Must be numeric letters</div>
                      </div>

                      <label for="giftImageURL">Image URL</label>
                      <b-form-input type="text" id="giftImageURL" placeholder="Enter Gift Image URL" v-model.trim="giftImageURL" :state="$v.giftImageURL.$error?false:null" @focus.native="$v.giftImageURL.$touch"></b-form-input>
                      <div v-if="$v.giftImageURL.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftImageURL.required">Gift url is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftImageURL.minLength">Must have at least {{ $v.giftImageURL.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftImageURL.maxLength">Must not exceed {{ $v.giftImageURL.$params.maxLength.max}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.giftImageURL.url">Must be valid url format</div>
                      </div>
                      <b-form-group label="Status" label-for="giftStatus" >
                        <c-switch class="mx-1" variant="success" :value="1" :pill="true" :uncheckedValue="0" v-model="giftStatus" id="giftStatus" @blur.native="$v.giftStatus.$error?false:null" />
                      </b-form-group>
                      <div v-if="$v.giftStatus.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.giftStatus.required">Gift Status is required</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="createGift" :disabled="$v.$invalid">Create Gift</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal">Cancel</b-btn>
    </b-modal> -->
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  import cSwitch from '../../../components/Switch'
  const {required, minLength, maxLength, minValue, maxValue, url, numeric} = require('vuelidate/lib/validators')
  export default {
    name: 'gift-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'DisplayName', label: 'Display Name'},
          {key: 'Quantity', label: 'Quantity'},
          {key: 'image', label: 'Image'},
          {key: 'Status', label: 'Status'}
          // {key: 'action', label: 'Action'}
        ],
        statusOption: [
          {label: 'Enable', value: '1'},
          {label: 'Disabled', value: '0'}
        ],
        sStatus: '1',
        currentPage: 1,
        perPage: 30,
        totalRows: 0,
        giftId: '',
        giftName: '',
        giftDisplayName: '',
        giftQuantity: 0,
        giftImageURL: '',
        giftStatus: 1
      }
    },
    validations: {
      giftName: { required, minLength: minLength(2), maxLength: maxLength(50) },
      giftDisplayName: { required, minLength: minLength(2), maxLength: maxLength(50) },
      giftQuantity: { required, numeric, minValue: minValue(0), maxValue: maxValue(9999999) },
      giftImageURL: { required, url, minLength: minLength(2), maxLength: maxLength(100) },
      giftStatus: { required, numeric, minValue: minValue(0), maxValue: maxValue(5) }
    },
    components: {
      cSwitch
    },
    watch: {
      currentPage: function () {
        this.getAllGifts()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getAllGifts () {
        let queryStr = `status=${this.sStatus || ''}`
        this.$http.get(this.API_ENDPOINT + '/luckywheel/gift/all?' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.gifts
          this.totalRows = response.data.gifts.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      updateGift () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/gift/update', {'id': this.giftId, 'name': this.giftName, 'displayName': this.giftDisplayName, 'quantity': this.giftQuantity, 'imageUrl': this.giftImageURL, 'status': this.giftStatus}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getAllGifts()
            this.closeEdit()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Gift Updated')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      createGift () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/gift/add', {'name': this.giftName, 'displayName': this.giftDisplayName, 'quantity': this.giftQuantity, 'imageUrl': this.giftImageURL, 'status': this.giftStatus}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getAllGifts()
            this.hideModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Gift Added')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      editGift (id) {
        this.items.forEach(item => {
          if (item.Id === id) {
            this.giftId = item.Id
            this.giftName = item.Name
            this.giftDisplayName = item.DisplayName
            this.giftQuantity = item.Quantity
            this.giftImageURL = item.ImageUrl
            this.giftStatus = item.Status
          }
        })
        this.$refs.editGift.show()
      },
      closeEdit () {
        this.$refs.editGift.hide()
      },
      showModal () {
        this.reset()
        this.$refs.createGift.show()
      },
      hideModal () {
        this.$refs.createGift.hide()
      },
      reset () {
        this.giftId = ''
        this.giftName = ''
        this.giftDisplayName = ''
        this.giftQuantity = 0
        this.giftImageURL = ''
      }
    },
    created () {
      this.getAllGifts()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/gift/GiftTable.vue